export class CreateNewFormRequestModel {
	constructor(public EntityId: number,
				public ScreenTypeId: number,
				public TableTypeId: number,
				public  FieldCollectionId: number) {
	}
}